import styled from 'styled-components';

export const Box = styled.div`
  width: 100%;
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    max-width: 260px;
  }
`;
